<!-- begin::Quick Sidebar -->
<!-- <div id="m_quick_sidebar" class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light"> -->
<div class="m-quick-sidebar__content">
	<span id="m_quick_sidebar_close" class="m-quick-sidebar__close">
		<i class="la la-close"></i>
	</span>
</div>
<!-- </div> -->
<!-- end::Quick Sidebar -->
